export const HOTEL_HOVERED = 'HOTEL_HOVERED';
export const HOTEL_CLICKED = 'HOTEL_CLICKED';
export const COUNT_HOTELS_FOR_SHOW_PENALIZED = 100;
